<template>
  <div class="text-13 h-6 flex items-center">
    <div class="text-13 h-6 flex items-center">{{ $t('evaluate_editor.data-transform') }}{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'DataTransformOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    title() {
      if (this.item?.payload?.title) {
        return ` - ${this.item?.payload?.title}`;
      }
      return '';
    },
  },
};
</script>
